import { render, staticRenderFns } from "./change-route.vue?vue&type=template&id=64022ee4&scoped=true&"
import script from "./change-route.vue?vue&type=script&lang=js&"
export * from "./change-route.vue?vue&type=script&lang=js&"
import style0 from "./change-route.vue?vue&type=style&index=0&id=64022ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64022ee4",
  null
  
)

export default component.exports